import { CustomerEventType } from "../customer-event/customer-event-definition";

export interface BaseStep {
  id: string;
  customTitle?: string;
}

/**
 * Keep in sync with the same enum in redo/temporal/workflows/run-automation/automation-activity-proxies
 * */
export enum StepType {
  // Marketing
  TRIGGER = "trigger", // check redo/temporal/workflows/run-automation.ts if this ever changes, it hardcodes "trigger"
  CONDITION = "condition",
  WAIT = "wait",
  WAIT_FOR_EVENT = "wait_for_event",
  DO_NOTHING = "do_nothing",
  SEND_EMAIL = "send_email",
  SEND_SMS = "send_sms",
  SEND_WEBHOOK = "send_webhook",
  AB_TEST = "ab_test",
  MANAGE_CUSTOMER_TAGS = "manage_customer_tags",
  RECOVER = "recover",

  // 1CU
  UPSELL = "upsell",
  DOWNSELL = "downsell",
  UPSELL_CONDITION = "upsell_condition",

  // OMS
  OMS_ACTION = "oms_action",
  OMS_CONDITION = "oms_condition",

  // Checkout personalization
  RCO_SPLIT = "rco_split",
  CHECKOUT_EXPERIENCE = "checkout_experience",
  RCO_SEGMENT = "rco_segment",
  BLOCK_CHECKOUT = "block_checkout",

  // Checkout packages
  RCO_CHECKOUT_PACKAGE = "rco_checkout_package",
  RCO_CHECKOUT_PACKAGE_CONDITION = "rco_checkout_package_condition",

  // Post-purchase flows
  POST_PURCHASE_PAGE = "post_purchase_page",
  POST_PURCHASE_SEGMENT = "post_purchase_segment",
  POST_PURCHASE_SPLIT = "post_purchase_split",

  // Tracking page flows
  TRACKING_PAGE = "tracking_page",

  // Support rules
  RULE_CONDITIONS = "rule_conditions",
  RULE_ACTIONS = "rule_actions",
}

export const supportedWaitForEventTypes = [
  CustomerEventType.MARKETING_CONFIRMED,
] as const;

export type SupportedWaitForEventType =
  (typeof supportedWaitForEventTypes)[number];

export enum AutomationFilter {
  Status = "Status",
  Channel = "Channel",
  Category = "Category",
}

export enum AutomationStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export enum AutomationChannel {
  Email = "Email",
  SMS = "SMS",
}

export enum AutomationSortKey {
  Name = "name",
  UpdatedAt = "updatedAt",
  Index = "index",
}

export const stepTypeDisplayNames: Partial<Record<StepType, string>> = {
  [StepType.DO_NOTHING]: "End",
  [StepType.WAIT]: "Wait",
  [StepType.WAIT_FOR_EVENT]: "Wait for event",
  [StepType.CONDITION]: "Branch",
  [StepType.SEND_SMS]: "Send SMS",
  [StepType.SEND_EMAIL]: "Send email",
  [StepType.SEND_WEBHOOK]: "Send webhook",
  [StepType.MANAGE_CUSTOMER_TAGS]: "Manage customer tags",
  [StepType.TRIGGER]: "Trigger",
  [StepType.UPSELL]: "Upsell",
  [StepType.DOWNSELL]: "Downsell",
  [StepType.UPSELL_CONDITION]: "Condition",
  [StepType.OMS_ACTION]: "Action",
  [StepType.OMS_CONDITION]: "Condition",
  [StepType.AB_TEST]: "A/B Test",
  [StepType.RCO_SPLIT]: "A/B Test",
  [StepType.CHECKOUT_EXPERIENCE]: "Checkout experience",
  [StepType.RCO_SEGMENT]: "Segment",
  [StepType.BLOCK_CHECKOUT]: "Block checkout",
  [StepType.RCO_CHECKOUT_PACKAGE]: "Package",
  [StepType.RCO_CHECKOUT_PACKAGE_CONDITION]: "Condition",
  [StepType.POST_PURCHASE_PAGE]: "Post-purchase page",
  [StepType.POST_PURCHASE_SEGMENT]: "Post-purchase segment",
  [StepType.POST_PURCHASE_SPLIT]: "A/B Test",
  [StepType.RECOVER]: "Recover",
  [StepType.TRACKING_PAGE]: "Tracking page",
  [StepType.RULE_CONDITIONS]: "Conditions",
  [StepType.RULE_ACTIONS]: "Actions",
};
